export default "__VITE_ASSET__D9lurLjm__"